import { Project } from '../shared'
import { ThisConnector } from '../../../../../api/connector'
import { BugtrackerRequest } from '../../../bugtrackers/api/shared'
import { buildApiPayloadBugtrackerCredentials } from '../../../bugtrackers/api/build-api-payload-bugtracker-credentials'

export interface GetProjectsArgs {
  organizationUuid?: string
  bugtrackerRequest: BugtrackerRequest | null
}

export interface GetProjectsResponse {
  data: Project[]
}

export async function getProjects(
  this: ThisConnector,
  { organizationUuid, bugtrackerRequest }: GetProjectsArgs
) {
  // Intentially a post request. Not a mistake
  const { data: projects } = await this.connector.post<GetProjectsResponse>(
    `/${organizationUuid}/bugtrackers/jira/projects?expand=skip_links`,
    buildApiPayloadBugtrackerCredentials(bugtrackerRequest)
  )
  return projects
}
